import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/admin/members")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const update = async (data) => {
  return await http
    .put(`/admin/members`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const removeMember = async (id) => {
  return await http
    .delete(`/admin/members/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll,
  update,
  removeMember
};
